import Functions from './Functions';

const Nengou = () => {
  return (
    <>
      <p id="displayNengou">年号</p>
      <p id="nangouInputField">{Functions.getNengou(Functions.getToDay())}</p>
    </>
  );
}

export default Nengou;